import contacts7 from './utils/contacts7.js';
import modal     from './utils/modal.js';
import videos    from './utils/video.js';

document.addEventListener('DOMContentLoaded', () => {
    contacts7();
    modal();
    videos();
});
